<style scoped>
    .emptyBox{
        display: flex;
        flex-direction: column;
        align-items: center;
    }
    .emptyImg{
        width: 4.26rem;
        height: 3.28rem;
        background: url("~assets/collection.png") no-repeat center/cover;
        margin-top: 2.28rem;
        margin-bottom: .7rem;
        font-size: .3rem;
        color: #6F6F6F;
    }
</style>
<template>
    <div style="padding-top: .98rem">
        <topbar text="我的收藏"></topbar>
        <div class="emptyBox" v-if="emptyStatus">
            <div class="emptyImg"></div>
            <div class="emptyName">你还没有收藏哦~</div>
        </div>
    </div>
</template>
<script>
    import {getSource, getSources} from "../api"

    import noMoreData from 'components/no-more-data'
    import topbar from 'components/topbar'
    import moment from 'moment/moment'

    import {Swiper, Slide} from 'vue-swiper-component';
    import {serialize} from 'utils/index'

    export default {
        data() {
            return {
//                EnvUrl: `https://oml9ntix5.qnssl.com/`, // 七牛图片
                EnvUrl: `https://cdn.ysqingxin.com/`,
                emptyStatus:true,
            }
        },
        components: {
            noMoreData,
            topbar,
            Swiper,
            Slide,
        },
        filters: {
            time(value) {
                let transTime = moment(value).format('YYYY-MM-DD HH:mm:ss')
                return transTime
            },
        },
        computed: {},
        methods: {

        },
        destroyed(){

        },
        mounted() {

        }
    }
</script>



// WEBPACK FOOTER //
// src/components/myCollection.vue?fbaa4cc6